import styled from 'styled-components';
import { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import imageCompression from 'browser-image-compression';
import toast from 'react-hot-toast';
import { Oval } from 'react-loader-spinner';
import { ReactComponent as UploadIcon } from '@/assets/icons/upload.icon.svg';

function FilePicker({ file, setFile }) {
  const [loading, setLoading] = useState(false);
  const [fileDetails, setFileDetails] = useState(null);

  const onDrop = useCallback(async (acceptedFiles, fileRejections) => {
    const baseUrl = `https://file.billboxx.com/upload`;

    fileRejections.forEach((file) => {
      file.errors.forEach((err) => {
        if (err.code === 'file-too-large') {
          toast.error(`File is larger than 10MB`);
        }

        if (err.code === 'file-invalid-type') {
          toast.error(`Error: ${err.message}`);
        }
      });
    });

    for (const acceptedFile of acceptedFiles) {
      let fileToUpload = acceptedFile;

      if (acceptedFile.type.startsWith('image/')) {
        // Resize the image
        const options = {
          maxWidthOrHeight: 500, // Ensures width is at least 500px
          maxWidth: 500, // Explicit width
          maxHeight: 250, // Explicit height
          useWebWorker: true,
        };

        try {
          fileToUpload = await imageCompression(acceptedFile, options);
        } catch (error) {
          console.error('Image compression error:', error);
          toast.error('Failed to resize image.');
          continue; // Skip uploading this file
        }
      }

      const formData = new FormData();
      formData.append('file', fileToUpload);
      // formData.append('upload_preset', import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET);

      try {
        setLoading(true);
        const response = await fetch(baseUrl, {
          method: 'POST',
          body: formData,
        });

        const data = await response.json();
        setFile(data?.data?.url);
        console.log(file);
        setFileDetails(data);
        console.log(fileDetails);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': [],
      'image/*': [],
    },
    maxFiles: 1,
    noClick: false,
    noKeyboard: false,
    maxSize: 10485760,
  });

  return (
    <PickerView file={file}>
      <Picker {...getRootProps()}>
        <input type="file" accept="image/*, application/pdf" {...getInputProps()} />

        <div className="title">
          {file ? (
            <span className="name">
              {/* {fileDetails?.original_filename}.{fileDetails?.format} */}
              {/* {file?.name} */}
              {file?.substring(file?.lastIndexOf('/') + 1) || 'File'}
            </span>
          ) : (
            <span className="placeholder">Click to upload document</span>
          )}
        </div>

        <div className="icon">
          {loading ? (
            <Oval color="#174078" secondaryColor="#D9DBE9" ariaLabel="loading" height={20} width={20} />
          ) : (
            <UploadIcon />
          )}
        </div>
      </Picker>
    </PickerView>
  );
}

export default FilePicker;


// export default FilePicker;

const PickerView = styled.div`
  width: 100%;
  height: 100%;
  margin-bottom: 30px;
  margin-top: 5px;
`;

const Picker = styled.div`
  width: 100%;
  height: 64px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors?.inputBackground};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  cursor: pointer;

  .title {
    display: flex;
    align-items: center;
    justify-content: center;

    .placeholder {
      font-size: 0.875rem;
      font-weight: 400;
      color: ${({ theme }) => theme.colors?.placeholder};
    }

    .name {
      font-size: 0.875rem;
      font-weight: 400;
      color: ${({ theme }) => theme.colors?.activeTitle};
    }
  }

  .icon {
    svg {
      width: 24px;
      height: 24px;
    }
  }
`;
